import { useMutation } from "@tanstack/react-query";
import {
  UpdateCompanyBody,
  UpdateCompanyResponse,
} from "api/schema/companies/companySchema";
import { AxiosError } from "axios";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

export const useUpdateCompany = ({ companyId }: { companyId: string }) => {
  const publicApi = usePublicApiService();
  return useMutation<UpdateCompanyResponse, AxiosError, UpdateCompanyBody>({
    mutationFn: (company) => publicApi.updateCompany({ companyId }, company),
  });
};
